import { SubscriptionStatus } from './types';

export const SUBSCRIPTION_STATES: Record<string, SubscriptionStatus> = {
  trialing: 'trial',
  trial_ended: 'trial_expired',
  on_hold: 'on_hold',
  canceled: 'canceled',
  expired: 'expired',
  past_due: 'past_due',
  unpaid: 'unpaid',
  paused: 'paused',
};
